import React, { ChangeEvent } from "react";
import styled from "styled-components";
import { Colors, Styleguide, theme } from "../theme";

const CheckboxText = styled.span`
  font-family: opensans-regular;
  font-size: ${Styleguide.fontSizes[16]};
  font-weight: ${Styleguide.fontWeights["regular"]};
  color: ${theme(Colors.black, Colors.gray[100])};
  text-align: left;
`;

const CheckboxContainer = styled.label`
  display: flex;
  flex-direction: row;
  ${CheckboxText} {
    margin-left: 8px;
    padding: 0;
    margin-top: 0;
    display: block;
  }
`;

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;

  :focus + span {
    outline-width: 2px;
    outline-style: solid;
    outline-offset: 2px;
    outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${theme(Colors.white, Colors.black)};
  stroke-width: 2px;
  margin: auto;
`;

type CheckboxProps = {
  checked: boolean;
  toggle?: (event: ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode | Array<React.ReactNode>;
};

const CheckboxCustom = styled.span<CheckboxProps>`
  display: flex;
  margin-top: 4px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: 12px;
  width: 12px;
  cursor: pointer;
  background: ${(props) =>
    props.checked
      ? theme(Colors.blue[100], Colors.lightBlue[100])
      : "transparent"};
  border: 2px solid
    ${(props) =>
      props.checked
        ? theme(Colors.blue[100], "transparent")
        : theme(Colors.blue[100], Colors.gray[100])};

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;

const Checkbox = ({ checked, toggle, children }: CheckboxProps) => {
  return (
    <CheckboxContainer>
      <CheckboxInput type="checkbox" checked={checked} onChange={toggle} />
      <CheckboxCustom checked={checked}>
        <Icon viewBox="2 3 20 28">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </CheckboxCustom>
      <CheckboxText>{children}</CheckboxText>
    </CheckboxContainer>
  );
};

export default Checkbox;
